export default function ModalTitle({title}){

    return(
        <div className="modal-title noselect">{title}</div>
    )
    
}